<template>
  <div :class="forSidebar ? 'sidebar-dropdown' : ''">
    <div class="dropdown-menus">
      <div :class="gravatar ? 'dropdown nav-item dropup' : 'dropdown nav-item'" v-for="menu in pmenus" v-bind:key="menu.name">
        <!-- Menu title -->
        <!-- For Sidebar Menu -->
        <a :id="menu.id" href="#" class="dropdown-toggle nav-link"
          :aria-labelledby="menu.id" aria-expanded="false" aria-haspopup="true"
          role="button" data-toggle="dropdown" v-if="menu.name == '%VueUser%'">
            <avatar :user="user" v-if="gravatar"></avatar>
            <user-name v-else :pro="isPaying">{{ gon.displayName }}</user-name>
          </a>

        <!-- For Admin Menu -->
        <a :id="menu.id" href="#" class="dropdown-toggle nav-link"
          :aria-labelledby="menu.id" aria-expanded="false" aria-haspopup="true"
          role="button" data-toggle="dropdown" v-else>{{ menu.name }}</a>

        <div class="dropdown-menu dropdown-menu-right nav-item">
          <template v-for="(link, idx) in menu.links">
            <!-- Display the username, with optional pro badge -->
            <template v-if="link.username">
              <div :key="menu.name + '-' + idx + '-username'">
                <span class="dropdown-item">
                  <user-name :pro="isPaying">{{ gon.displayName }}</user-name>
                </span>
                <div class="dropdown-divider"></div>
              </div>
            </template>

            <!-- A regular link -->
            <a class="dropdown-item" :class="link.class" v-else-if="link.url && !current_url(link.url)"
              @click="track(menu.name, link, $event)"
              :href="link.url"
              :key="link.url"
              :data-testid="link.title ? 'dropdown-link-' + getMenuLinkId(link.title) : false">{{ link.title }}
            </a>

            <!-- A "link" to where we already are -->
            <span class="dropdown-item" v-else-if="link.url"
              :key="menu.name + '-' + idx + '-here'">{{ link.title }}
            </span>

            <!-- A divider -->
            <div v-else-if="link.divider"
              class="dropdown-divider"
              :key="menu.name + '-' + idx + '-divider'">
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import track from '../tracking';
import UserName from '@cmp/user_name.vue';
import Avatar from '@cmp/shared/avatar';

var md5 = require('md5')

export default {
  components: { UserName, Avatar },
  props: {
    menus: String,
    gravatar: Boolean,
    forSidebar: Boolean
  },
  methods: {
    current_url: (url) => {
      let baseUrl=window.location.protocol+"//"+window.location.host+"/"+window.location.pathname.split('/')[1];
      let current=new URL(window.location.pathname+window.location.search+window.location.hash,baseUrl);

      let destUrl=url.includes("//")? new URL(url):new URL(url,baseUrl);
      return current.toString() == destUrl.toString();
    },
    getMenuLinkId: (title) => {
      return title.replace(/ /g,"_").toLowerCase();
    },
    track: function (menu, link, event) {
      if (link.method === "delete" && link.type === "json") {
        event.preventDefault();
        Rails.ajax({
          type: "DELETE",
          url: link.url,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: function (resp) {
            // handle common response: see ajaxResponseHandler.js
            if(resp.metadata && resp.metadata.message) {
              window.localStorage.setItem('flash', resp.metadata.message);
            }
            if(resp.metadata && resp.metadata.redirect_to) {
              window.location.href = resp.metadata.redirect_to;
            }
          },
          error: function (e) {
            console.log(e);
          }
        });
      }

      if (link.trackable) {
        track("viewer_clicked_menu_item", {
          url: this.$route.fullPath,
          type: link.title.toLowerCase().replaceAll(" ", "_"),
          from: "profile_nav_menu",
        })
      }
    }
  },
  watch: {
    $route: function(_newVal, _oldVal){
      // vue router changes are not picked up, the menu thinks is still on a given path when it's not.
      // need to refresh it on route change
      this.$forceUpdate();
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      isPaying: state => state.currentOrganization.attributes.is_paying
    }),
    pmenus: function() {
      return JSON.parse(this.menus);
    }
  }
}
</script>

<style scoped lang="scss">
// TODO: I feel like we could have webpacker inject this.
@import '../../packs/application.scss';

.sidebar-dropdown {
  .dropdown-menus {
    .dropdown {
      margin: 0;
    }
    .nav-link {
      padding: 0
    }
  }
  .dropdown-toggle::after {
    display: none
  }
}

.avatar-img {
  border-radius: 2rem;
}

.dropdown-menus {
  display: flex;

  .dropup {
    .dropdown-menu  {
      top: 3rem !important;
      left: 4rem !important;
    }
  }

  .dropdown {
    margin-left: 20px;

    a {
      color: $black;
      text-decoration: none;
      line-height: 62px;

      &.download-cloudapp {
        color: $bright-blue;
      }

      .dropdown-toggle {
        font-size: 0.75rem;
        font-weight: 600;
      }

      .dropdown-toggle::after {
        vertical-align: 2px;
      }
    }
  }

  .nav-item {
    .nav-link {
      font-family: 'SFPro';
      font-size: 0.75rem;
      line-height: 1rem;
      font-weight: 600;
    }
  }

  .dropdown-menu {
    font-size: 14px;
    left: auto;
    top: 3px;
    border-radius: 8px;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2), 0 0 3px 0 rgba(0, 0, 0, 0.17);
    z-index: $cta-highest-z;

    .dropdown-divider {
      border-style: solid;
      color: $white-four;
      border-width: 1px;
      margin: 10px 15px 10px 15px;
    }

    .dropdown-item {
      padding-left: 15px;
      padding-right: 15px;
      font-weight: normal;
      line-height: 26px;
    }

    .dropdown-item.upgrade {
      color:$orange;
    }

    span.dropdown-item {
      cursor: default;
      font-weight: bold;
    }
  }
}
</style>
